import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { unsafeUseFormReturnSubset } from '@ipfabric/ui-components/utils/formSnippets/unsafeUseFormReturnSubset';
import { DeviceCredentials } from '../../../components/Authentication/DeviceCredentials';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import {
  type DeviceCredentialsFieldValues,
  storedDeviceCredentials,
} from '../../../snippets/storedDeviceCredentials';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const deviceCredentialsGroup = createFormSnippetGroup({
  snippets: {
    storedDeviceCredentials,
  },
  render: ({ renderSnippet, form }) => (
    <SearchableSection
      id='device-credentials'
      searchTerms={['Device Credentials']}
      className='flex flex-col flex-1'
      wrapperClassName='flex flex-col flex-1'
    >
      <DeviceCredentials
        form={unsafeUseFormReturnSubset(form)<
          keyof DeviceCredentialsFieldValues
        >()}
        renderSnippet={renderSnippet}
      />
    </SearchableSection>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('authentication');
    control.setAuthenticationSubTab('deviceCredentials');
  },
});
